'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  $('a.social-share').on('click', function () {
    var popup,
      service = $(this).data('service'),
      title = $(this).data('title'),
      base = window.location.origin,
      path = window.location.pathname,
      url = base + path;
    if (service === 'facebook') {
      popup = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    } else if (service === 'twitter') {
      popup = 'http://twitter.com/intent/tweet?via=universalorl&amp;url=' + url;
    } else if (service === 'email') {
      popup = 'mailto:?subject=' + title + '&body=' + url;
    }
    window.open(popup, service, "height=" + 300 + ",width=" + 600);
  });
})(jQuery);
